import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';
import {HttpClient} from '@angular/common/http';
import {AngularFireAuth} from '@angular/fire/auth';
import {AngularFireDatabase} from '@angular/fire/database';
import {take} from 'rxjs/operators';
import {Sport} from '../models/sport/sport';
const CONFIG = {
  space: '8zj29nvml0ec',
  accessToken: '_Xo9xU4bT4R_kacUwbZ1HRpYRsV_X7RsXk3b09MN38s',

  contentTypeIds: {
    product: '2PqfXUJwE8qSYKuM0U6w8M'
  }
};

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {
  private cdaClient = createClient({
    space: CONFIG.space,
    accessToken: CONFIG.accessToken
  });
  allAccess = false;
  sports = [];
  constructor(private http: HttpClient, private firebaseAuth: AngularFireAuth, private db: AngularFireDatabase) {
    this.firebaseAuth.authState.pipe(take(1)).subscribe(auth => {
      if (auth) {
        const userId = auth.uid;
        const userDeets = this.db.object(`users/${userId}`).valueChanges().subscribe((res: any) => {
          if (res.allAccess) {
            this.allAccess = true;
          } else {
            this.allAccess = false;
          }
        });
      }
    });
    this.getSports();
  }

  getSports(): void {
    this.cdaClient.getEntries(Object.assign({
      content_type: 'sport'
    }, {order: 'fields.displayPriority'})).then(res => {
      res.items.forEach((i: any) => {
        this.sports.push(new Sport(i.fields.name, i.fields.displayPriority));
      });
    });
  }

  getLiveEvents(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: 'liveEvent'
    }, query))
      .then(res => res.items);
  }

  getOnDemandEvents(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: 'onDemandEvent'
    }, query))
      .then(res => res.items);
  }

  getEntry(id, query?: object): Promise<Entry<any>> {
    return this.cdaClient.getEntry(id);
  }
}
